import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { NEW_RELIC_SCRIPT } from './types';
export default _defineProperty({}, NEW_RELIC_SCRIPT, function (state) {
  return state.newRelicScript;
});